<script setup>
import bgHero from '@/assets/img/bg-gradient-smilepicture.png'
import tvCommercial from '@/assets/img/services/our-services-3.png'
import OurProcess from '../../components/OurProcess.vue';
import SomeOfWorks from '../../components/SomeOfWorks.vue';
import TypesOfAnimationWeCreate from '../../components/TypesOfAnimationWeCreate.vue';
import { ref, onMounted } from 'vue'
import { fetchWorks } from '@/services/api'
const loading = ref(false)
const works = ref([])
const meta = ref({})
const fetchWorksData = async () => {
    loading.value = true
    try {
        const result = await fetchWorks({ service_slug: 'video-animation' })
        works.value = result.data
        meta.value = result.meta
    } catch (error) {
        console.error('Failed to fetch works:', error)
        works.value = []
    } finally {
        loading.value = false
    }
}

onMounted(() => {
    fetchWorksData()
})
</script>

<template>
    <!-- HERO SECTION -->
    <section class="video-wrapper px-0 mt-0 min-vh-80 d-flex align-items-center" :style="{
        backgroundImage: `url(${bgHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14">
            <div class="row gx-md-8 gx-xl-12 gy-10 align-items-center">
                <!-- TEXT -->
                <div class="col-lg-6 text-start text-lg-start">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/services">Services</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Animation Video</li>
                        </ol>
                    </nav>

                    <h1 class="display-2 mb-4 text-secondary">
                        Animation That Explains, Engages, and Inspires
                    </h1>

                    <p class="lead text-white">
                        We create visually compelling animation videos that simplify complex ideas, strengthen brand
                        messages, and connect with audiences through creative storytelling.
                    </p>
                </div>

                <!-- LOGO -->
                <div class="col-lg-6 d-flex align-items-center justify-content-center">
                    <img class="img-fluid" :src="tvCommercial" :srcset="`${tvCommercial} 2x`"
                        alt="Smile Picture Logo" />
                </div>
            </div>
        </div>
    </section>

    <!-- About TV -->
    <section class="wrapper px-0 bg-black">
        <div class="container pt-10 pb-12 pt-md-14 pb-md-16">
            <div class="row">
                <div class="mx-auto text-white text-center">
                    <h1 class="display-1 mb-3 text-white">
                        About <span style="color: #ffae0b;">Animation Video Services</span>
                    </h1>

                    <p class="lead">
                        Animation video is one of the most effective ways to communicate ideas clearly and creatively.
                        At SmilePictures, we design animation content that blends visual storytelling, motion, and
                        sound—making information easier to understand and more engaging to watch.
                        <br>
                        From explainer videos to brand animations, we help turn messages into visuals that resonate.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- Type of Animation We Create Section -->
    <TypesOfAnimationWeCreate />

    <section class="wrapper px-0 bg-black">
        <div class="container pt-10 pb-12 pt-md-14 pb-md-16">
            <div class="row mt-5 d-flex align-items-stretch justify-content-center">

                <!-- CARD 1 -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 mb-4 d-flex">
                    <div class="card service-card d-flex flex-column" style="flex-grow:1; background:#33393f; backdrop-filter:blur(12px);
      border-radius:2rem; box-shadow:0 4px 30px rgba(0,0,0,0.15);
      overflow:hidden; width:100%;" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                        <div class="card-body px-3 pb-10 pt-10">

                            <h4 class="card-title mb-4 text-secondary text-center">
                                Why Animation Video Matters
                            </h4>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Delivers messages clearly and efficiently
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Increases audience engagement and retention
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Makes complex information easier to understand
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Enhances brand identity with visual consistency
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Works effectively across digital platforms
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- CARD 2 -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 mb-4 d-flex">
                    <div class="card service-card d-flex flex-column" style="flex-grow:1; background:#33393f; backdrop-filter:blur(12px);
      border-radius:2rem; box-shadow:0 4px 30px rgba(0,0,0,0.15);
      overflow:hidden; width:100%;" data-aos="fade-up" data-aos-duration="800" data-aos-delay="150">
                        <div class="card-body px-3 pb-10 pt-10">

                            <h4 class="card-title mb-4 text-secondary text-center">
                                Why Choose SmilePictures
                            </h4>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Creative team with strong visual storytelling skills
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Custom animation style tailored to your brand
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Clear narrative and structured message delivery
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    High-quality visuals and smooth motion design
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Collaborative and efficient production process
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <!-- Our Process Section -->
    <OurProcess />

    <!-- Some Of Works Carousel -->
    <SomeOfWorks v-if="!loading" :works="works" :meta="meta" />
</template>

<style>
.wrapper {
    overflow-x: relative;
}

.hero-service-image {
    height: 13rem;
    max-width: 100%;
}

/* Tablet */
@media (max-width: 991.98px) {
    .hero-service-image {
        height: 11rem;
    }
}

/* Mobile */
@media (max-width: 575.98px) {
    .hero-service-image {
        height: 9rem;
    }
}
</style>
